export default __webpack_public_path__ + "9665a8830b7013e99f6ab71e050cc7cb.png";